import React from "react";
import { InventoryControlPanel } from "./InventoryControlPanel";
import { InventoryTable } from "./InventoryTable";

export const ItemsMasterView = ({
  search,
  setSearch,
  filters,
  setFilters,
  dynamicSettings,
  activeTab,
  filtered,
  setRestockItem,
  handleEdit,
  handleViewPurchases,
  deleteItem,
  distributedMap,
  purchasedMap
}) => {
  return (
    <>
      <InventoryControlPanel
        activeTab={activeTab}
        search={search}
        setSearch={setSearch}
        filters={filters}
        setFilters={setFilters}
        dynamicSettings={dynamicSettings}
        statusPlaceholder="All Status"
      />
      <InventoryTable
        filtered={filtered}
        activeTab={activeTab}
        onRestockClick={setRestockItem}
        onEditClick={handleEdit}
        onViewClick={handleViewPurchases}
        onDeleteClick={deleteItem}
        distributedMap={distributedMap}
        purchasedMap={purchasedMap}
      />
    </>
  );
};

